<template>
	<div class="container">
		<div class="privacy">
			<div class="policy">
				<div class="policy-title">公司成长 Company growth</div>
				<div class="policy-content">
					<div class="policy-c-view">
						<!-- <h3>播聘深圳总部</h3> -->
						<p>播聘自2019年7月推出以来，短短数周，用户量已达3600万，营收超过1.5亿，保持着快速稳定的增长势头。</p>
						<div><img src="../../../static/companyGrow1.png" alt=""></div>
						<!-- <p>邮编:518057</p>
						<p>客服电话: 0755-8254 0116</p> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:`CompanyGrow`
	}
</script>

<style scoped="scoped">
	@import url("./company-grow.css");
</style>



// WEBPACK FOOTER //
// src/pages/company-grow/company-grow.vue